<div ngbTooltip="Units"
     container="body">
  <div ngbDropdown
       container="body">
    <button ngbDropdownToggle
            class="btn btn-sm btn-light m-0 p-0 px-1"
            style="font-size: 9px"
            [innerHtml]="columnUnits">
    </button>
    <div ngbDropdownMenu>
      <ng-container *ngFor="let units of column.units">
        <ng-container *ngIf="units !== columnUnits">
          <button ngbDropdownItem
                  class="btn btn-sm"
                  [innerHtml]="units"
                  (click)="columnUnitsChanged(units)">
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
